(function ($) {
	var successText;
	var ajaxCall = {
		readyState: 4,
	};
	var freeProducts = 0;
	var quantity = 0;
	var productId = $('body').data('productId');
	var checkedClass = $('.product__crossell__wrapper').data('checkedClassName');
	var obj = {};
	if (ajaxCall.readyState == 4) {
		$(".quantity-selector .custom-select select").change(function (e) {
			var selectWidth = $(this).find(":selected").data("width");
			var $productCrossSellElements = $('.product__crossell[data-product-id="'+ $(this).data('productId') +'"]');

			$productCrossSellElements.find(".custom-select").css("width", selectWidth);
			$productCrossSellElements.find(".select-selected").html( $(this).parents(".custom-select").find(".select-selected").html() );

			successText = $(this).parents(".product__crossell").find(".successfully-added-text span.change-text");

			quantity = $(this).find(":selected").data("count");
			freeProducts = Math.floor(parseInt(quantity) / 3);
			if ($(this).parents(".product__crossell").data("isTwoPlusOne")) {
				if (freeProducts > 0) {
					$productCrossSellElements.addClass("activated");
					calculateOldNewPrice($(this).parents(".product__crossell"), quantity);

					if ($(this).find(":selected").data("text")) {
						successText.html(successText.data("text").replace("%how_many%", $(this).find(":selected").data("text")));
						$productCrossSellElements.find(".successfully-added-text span.change-text").html(successText.data("text").replace("%how_many%", $(this).find(":selected").data("text")));
					}
				} else {
					$productCrossSellElements.removeClass("activated");
					calculateOldNewPrice($(this).parents(".product__crossell"), quantity);
				}
			}

			$(".product__crossell__wrapper").addClass("loading");
			__enableLoader($(".product__crossell__wrapper"));
			ajaxCall = mobileCart.updateProductCrossSellQuantity($(this).parents(".product__crossell"), function () {
				$(".product__crossell__wrapper").removeClass("loading");
				__disableLoader($(".product__crossell__wrapper"));
			});
			updateDataTag($(this).parents(".product__crossell"));
		});
	}

	$(".product__crossell .take-advantage-btn").click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		$(this).parents(".product__crossell").find(".quantity-selector .custom-select .select-items div").eq(0).click();

		$('.product__crossell[data-product-id="'+ $(this).data('productId') +'"]').addClass('activated');		
	});

	$(".product__crossell").on("click", function (e) {
		var _self = $('.product__crossell[data-product-id="'+ $(this).data('productId') +'"]');
		if (ajaxCall.readyState == 4) {
			if (!_self.hasClass(checkedClass)) {
				_self.addClass(checkedClass);

				if ($(".product__crossell__wrapper").eq(0).find(".product__crossell").length >= 3) {
					$(".product__crossell__wrapper").addClass("three-open");
					setTimeout(function () {
						if ($(".product__crossell__wrapper").eq(0).find(".product__crossell").length > 2) {
							$(".product__crossell__wrapper").each(function() {
								$(this).find(".product__crossell").eq(2).slideDown();
							});

							obj = {
								event_category: productId,
								event_action: "impression_ics",
								event_label: $(".product__crossell").eq(2).data('productId')
							};
							gatgEvent(obj);
						}
					}, 1000);
				}

				$(".product__crossell__wrapper").addClass("loading");
				__enableLoader($(".product__crossell__wrapper"));
				ajaxCall = mobileCart.addProductCrossSell(_self, function () {
					$(".product__crossell__wrapper").removeClass("loading");
					__disableLoader($(".product__crossell__wrapper"));

					setTimeout(function() {					
						_self.find('.custom-select .select-selected').addClass('green--glow-once');
					}, 500);
				});

				updateDataTag(_self);
			} else {
				if ($(e.target).parents(".quantity-selector").length) {
					return;
				}
				if ($(e.target).hasClass("product__crossell__content") || $(e.target).parents(".product__crossell__content").length) {
					_self.removeClass(checkedClass);

					$(".product__crossell__wrapper").addClass("loading");
					__enableLoader($(".product__crossell__wrapper"));
					ajaxCall = mobileCart.removeProductCrossSell(_self, function () {
						$(".product__crossell__wrapper").removeClass("loading");
						__disableLoader($(".product__crossell__wrapper"));
					});
				}
			}

			if (_self.hasClass(checkedClass)) {
				$(".product__crossell__wrapper").addClass("selected-" + _self.data("index"));
			} else {
				$(".product__crossell__wrapper").removeClass("selected-" + _self.data("index"));
			}

			setTimeout(function () {
				/* Trigger reflow, to restart animations */
				$(".product__crossell .checkbox").each(function (i, el) {
					$(el).removeClass("green--glow--delay5s");
					$(el)[0].offsetHeight;
					$(el).addClass("green--glow--delay5s");
				});
			}, 1500);
		}
	});

	$(".product__crossell").each(function () {
		var quantity = $(this).find(".custom-select select").data("onLoadQuantity");
		calculateOldNewPrice($(this), quantity);
		updateDataTag($(this), quantity);
	});

	var alreadyPushedIds = [];
	$(".product__crossell").each(function (index, el) {		
		var icsProductId = parseInt($(el).data('productId'))
		if($(el).css('display') != "none") {
			obj = {
				event_category: productId,
				event_action: "impression_ics",
				event_label: icsProductId
			};
			if(alreadyPushedIds.indexOf(parseInt(icsProductId)) === -1) {
				gatgEvent(obj);
			}
			alreadyPushedIds.push(parseInt(icsProductId));	
		}
	});

	function updateDataTag($productCrossSellContainer, quantity) {
		if($productCrossSellContainer.length) {
			if (typeof quantity == "undefined") {
				quantity = $productCrossSellContainer.find(":selected").data("count");
			}
			$productCrossSellContainer.data("tag", $productCrossSellContainer.data("tagProto").replace("%qty%", quantity));
		}
	}

	function calculateOldNewPrice($productCrossSellContainer, quantity) {
		var freeProducts = Math.floor(quantity / 3);
		var oldPrice = parseFloat($productCrossSellContainer.data("price"));
		var newPrice = oldPrice * quantity - oldPrice * freeProducts;
		var oldPriceWithQuantity = oldPrice * quantity;

		$('.product__crossell[data-product-id="'+ $productCrossSellContainer.data('productId') +'"]')
			.find(".price.old-price")
			.text("+" + oldPriceWithQuantity.toFixed(window.jstransobj.currencyPrecision) + " " + window.jstransobj.currencySymbol);
		$('.product__crossell[data-product-id="'+ $productCrossSellContainer.data('productId') +'"]')
			.find(".price.new-price")
			.text("+" + newPrice.toFixed(window.jstransobj.currencyPrecision) + " " + window.jstransobj.currencySymbol);

		var hrkTransitionPrice = newPrice / window.jstransobj.currencyRatio;
		if(window.jstransobj.getArithmeticOperator == '*') {
			hrkTransitionPrice = newPrice * window.jstransobj.hrkTransitionCurrencyRate;
		}

		$('.product__crossell[data-product-id="'+ $productCrossSellContainer.data('productId') +'"]')
			.find('.in-eur')
			.text("(" + (hrkTransitionPrice).toFixed(window.jstransobj.currencyPrecision) + " " + window.jstransobj.hrkTransitionCurrency + ")");
	}
})(jQuery);
